import { textStyleCss } from 'src/theme/atlas';
import styled, { DefaultTheme } from 'styled-components';

interface ContainerTextThemeProps {
  isSelected?: boolean;
  disabled?: boolean;
  theme: DefaultTheme;
}

const getBackgroundColor = (props: ContainerTextThemeProps) => {
  if (props.disabled) {
    return props.theme.atlas.semantic.color.surface.default;
  }
  if (props.isSelected) {
    return props.theme.atlas.semantic.color.selection.secondary.default;
  }
  return props.theme.atlas.semantic.color.surface.default;
};

const getBorderColor = (props: ContainerTextThemeProps) => {
  if (props.disabled) {
    return props.theme.atlas.semantic.color.ui.divider.default;
  }
  if (props.isSelected) {
    return props.theme.atlas.semantic.color.outline.default;
  }
  return props.theme.atlas.semantic.color.outline.default;
};

export const ContainerTextStyled = styled.div<{
  isSelected?: boolean;
  disabled?: boolean;
  margins?: string;
  hasDescription: boolean;
  isFixedWidth: boolean;
}>`
  ${(props) => (props.isFixedWidth ? 'width: 140px;' : 'max-width: 100%;')}
  height: 100px;
  background-color: ${(props) => getBackgroundColor(props)};
  border: ${(props) => `1px solid ${getBorderColor(props)}`};
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${(props) => (props.hasDescription ? 'flex-end' : 'center')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  padding: 15px 20px;
  ${(props) => props.margins && `margin: ${props.margins};`}
  @media (hover: hover) {
    &:hover {
      ${(props) =>
        !props.disabled &&
        props.isSelected &&
        `
        background-color: ${props.theme.atlas.semantic.color.selection.secondary.hover};
      `}
      ${(props) =>
        !props.disabled &&
        !props.isSelected &&
        `
        background-color: ${props.theme.atlas.semantic.color.action.secondary.hoverFill};
      `}
    }
  }
  &:active {
    ${(props) =>
      !props.disabled &&
      props.isSelected &&
      `
      background-color: ${props.theme.atlas.semantic.color.selection.secondary.active};
    `}
  }
`;

export const MainText = styled.p`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
  text-align: center;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
`;

export const DescriptionText = styled.p`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 1px 0 2px 0;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;
